import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { trackPageLoad } from '@fff-web/fff-analytics';
import { Button } from '@fff-web/fff-ui-shared';
import Layout from '../../components/Layout';
import { baseSiteUrl } from '../../utils/env';
import girlsImg from '../../assets/images/confirmation-image.jpg';
import * as styles from './UpgradeThanks.module.scss';

interface LocationState {
  coupon_code?: string;
}

interface UpgradeThanksProps {
  location: {
    state?: LocationState;
  };
}

export const UPGRADE_MESSAGES = {
  pageTitle: 'Upgrade Page',
  successMessage: 'Success!',
  nowAnnualMember: 'You’re Now an Annual Member!',
  successMessageDesktop: 'Success! You’re Now an Annual Member!',
  thankYouMessage1:
    'Thank you for upgrading. Your Annual subscription confirmation will arrive shortly via email. Prepare for a year of FabFitFun boxes, extra savings, and exclusive access to our biggest sales.',
  thankYouMessage2:
    'You’ll receive notifications via email when Annual personalization options are available.',
  submitButtonLabel: 'GO TO DASHBOARD',
  altImage: 'Two individuals are smiling and holding FabFitFun boxes',
  pathName: '/upgrade-thanks',
  submitTestId: 'go-to-dashboard-button',
};

const UpgradeThanks = ({ location: { state } }: UpgradeThanksProps) => {
  const { chatbotAppliedLab: showChatbot } = useFlags();

  useEffect(() => {
    trackPageLoad({
      pathName: UPGRADE_MESSAGES.pathName,
      properties: { coupon_code: state?.coupon_code },
    });
  }, [state?.coupon_code]);

  const onReturnToDashboard = () => window.location.assign(baseSiteUrl);

  return (
    <Layout pageTitle={UPGRADE_MESSAGES.pageTitle} hideChatWidget={!showChatbot}>
      <section className={styles.upgradeThanks}>
        <h2 className={styles.mobileTitle}>
          <span>{UPGRADE_MESSAGES.successMessage}</span>
          <span>{UPGRADE_MESSAGES.nowAnnualMember}</span>
        </h2>
        <div className={styles.imageContainer}>
          <img src={girlsImg} alt={UPGRADE_MESSAGES.altImage} />
        </div>
        <div className={styles.messageContainer}>
          <h2 className={styles.desktopTitle}>{UPGRADE_MESSAGES.successMessageDesktop}</h2>
          <p>{UPGRADE_MESSAGES.thankYouMessage1}</p>
          <p>{UPGRADE_MESSAGES.thankYouMessage2}</p>
          <Button
            data-testid={UPGRADE_MESSAGES.submitTestId}
            className={styles.submitButton}
            onClick={onReturnToDashboard}
          >
            {UPGRADE_MESSAGES.submitButtonLabel}
          </Button>
        </div>
      </section>
    </Layout>
  );
};

export default UpgradeThanks;
